"use client";

import { useInfront } from "@/context/infront-context";
import {
  createInstrumentSlug,
  DEFAULT_CONTENT,
} from "@/services/infront/utils";
import { useRouter } from "next/navigation";
import { useEffect, useRef } from "react";

const ID = "global-index-list";

const INDICIES = [
  {
    feed: 2302,
    ticker: "BFR40P",
  },
  {
    feed: 2302,
    ticker: "BDE40P",
  },
  {
    feed: 2198,
    ticker: "HSI",
  },
  {
    feed: 2087,
    ticker: "COMP",
  },
  {
    feed: 6150,
    ticker: "N225",
  },
  {
    feed: 18177,
    ticker: "OBX",
  },
  {
    feed: 17665,
    ticker: "OMXC25",
  },
  {
    feed: 100,
    ticker: "OMXH25",
  },
];

const GlobalIndexList = () => {
  const router = useRouter();
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(
      () => {
        if (!isReady || !active) return;

        widgetRef.current?.destroy();
        widgetRef.current = null;

        const widgetOptions = new window.Infront.QuoteListWidgetOptions();

        widgetOptions.onInstrumentSelected = (instrument: {
          feed: number;
          ticker: string;
        }) => {
          router.push(
            createInstrumentSlug(instrument.feed, instrument.ticker)
          );
        };

        widgetOptions.instruments = INDICIES.map(
          (index) => new window.Infront.Instrument(index.feed, index.ticker)
        );

        widgetOptions.widgetTitle = "Index";
        widgetOptions.defaultContent = DEFAULT_CONTENT;
        widgetOptions.sortable = true;
        widgetOptions.enableChangeStatusColors = true;

        widgetOptions.columns = [
          {
            name: "FULL_NAME",
            flag: true,
          },
          "LAST",
          "CHANGE",
          "PCT_CHANGE",
          "ONE_W_PCT_CHANGE",
          "YTD_PCT_CHANGE",
          "ONE_Y_PCT_CHANGE",
          "FIVE_Y_PCT_CHANGE",
          "TIME",
        ];

        widgetRef.current = window.infront.quoteList(`#${ID}`, widgetOptions);
      }
    );

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router]);

  return <div className="card" id={ID} />;
};

export default GlobalIndexList;
